(ns practitest.frontend.components2.entity-form.jira-user-list-input
  (:require
   [goog.object :as g]
   [goog.string :as gstring]
   [practitest.frontend.components.searchable-list :refer [searchable-async-select]]
   [practitest.frontend.components2.entity-form.base-control :refer [base-control]]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.subs :as subs]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]))

(defn transform
  "Transform users data into react-select format"
  [data]
  (let [users (get data :users)]
    (when users
      (clj->js
       (mapv (fn [user]
               {:id (:value user)
                :value (:value user)
                :label (:label user)})
             users)))))

(defn fetch-selected-value [project-id bugtracker-id issue_type_id base-value initial-value external-id]
  (let [encoded-base-value (js/encodeURIComponent base-value)
        url (broutes/get-url "integration_setting_jira_two_ways#get_user_id_by_name"
                             {:project_id project-id
                              :integrated_bugtracker_id bugtracker-id
                              :issue_type_id issue_type_id})]
    (let [request-url (gstring/format url encoded-base-value 0 1 issue_type_id)
          request-url (if external-id
                        (str request-url "&external_id=" (js/encodeURIComponent external-id))
                        request-url)]
      (-> (.fetch js/window request-url #js {:credentials "include"})
          (.then (fn [response]
                   (if (.-ok response)
                     (.json response)  ;; Parse JSON response
                     (throw (js/Error. (str "Failed to fetch: " (.-status response)))))))
          (.then (fn [data]
                 ;; Correctly access the first user 
                   (let [users (g/get data "users")]
                     (when users
                       (when-let [user (first (array-seq users))]
                         (reset! initial-value
                                 {:id    (.-value user)
                                  :value (.-value user)
                                  :label (.-label user)}))))))
          (.catch (fn [err]
                    (js/console.error "Failed to fetch initial value:" err)))))))

(defn jira_user_list [{:keys [base-value
                              issue_type_id
                              external-id
                              label-fn
                              key-fn
                              on-change]
                       :as props}]
  (let [project @(re-frame/subscribe [::subs/current-project])
        initial-value (reagent/atom nil)
        url (broutes/get-url "integration_setting_jira_two_ways#get_user_id_by_name"
                             {:issue_type_id issue_type_id
                              :project_id (:id project)
                              :integrated_bugtracker_id (:integrated_bugtracker_id project)})
        url (if external-id
              (str url "&external_id=" (js/encodeURIComponent external-id))
              url)
        ;; Track component updates with watchable state
        component-update (reagent/atom 0)]
    (reagent/create-class
     {:component-did-mount
      (fn []
        (fetch-selected-value
         (:id project)
         (:integrated_bugtracker_id project)
         issue_type_id
         base-value
         initial-value
         external-id))

      :component-did-update
      (fn [this old-argv]
        ;; Force component update when initial-value changes
        (when (not= @initial-value (second old-argv))
          (swap! component-update inc)))

      :reagent-render
      (fn [props]
        [base-control (assoc props :custom-control? true)
         [searchable-async-select
          (assoc props
                 :url url
                 :value @initial-value ;; Change from :base-value to :value
                 :label-fn label-fn
                 :key-fn key-fn
                 :page-size 100
                 :issue_type_id  issue_type_id 
                 :transform transform
                 :on-change (fn [value]
                              (on-change value)
                              (reset! initial-value value))
                 :styles (clj->js
                          {:container (fn [provided]
                                        (merge provided
                                               {:width "100%"}))
                           :control (fn [provided]
                                      (merge provided
                                             {:width "100%"}))
                           :menu (fn [provided]
                                   (merge provided
                                          {:width "100%"}))}))]])})))